import { render, staticRenderFns } from "./projectTypeView.vue?vue&type=template&id=109e804c&"
import script from "./projectTypeView.vue?vue&type=script&lang=js&"
export * from "./projectTypeView.vue?vue&type=script&lang=js&"
import style0 from "./projectTypeView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports